import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/feature/LanguageSwitcher';

export default function CompanyPage() {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'マンダラチャート認定講師 代表 阿高佳男 | 株式会社LIKES 会社概要 福岡市 組織開発';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '株式会社LIKESの会社概要。マンダラチャート認定講師の代表取締役 阿高佳男（Yoshio ATAKA）。マンダラチャートを活用した組織風土改革・人材育成と、B2Bキャッシュレス決済導入支援で福岡市の企業の持続的成長を支援します。');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/company`);
    }
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schemas = [
      { id: 'schema-organization-co', data: { '@context': 'https://schema.org', '@type': 'Organization', '@id': `${siteUrl}/#organization`, name: '株式会社LIKES', url: siteUrl, foundingDate: '2015-06', address: { '@type': 'PostalAddress', streetAddress: '香椎照葉3-2-7', addressLocality: '福岡市東区', addressRegion: '福岡県', postalCode: '813-0017', addressCountry: 'JP' } } },
      { id: 'schema-breadcrumb-co', data: { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: [{ '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` }, { '@type': 'ListItem', position: 2, name: '会社概要', item: `${siteUrl}/company` }] } },
    ];
    schemas.forEach(({ id, data }) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(data);
      script.id = id;
      document.head.appendChild(script);
    });
    return () => { schemas.forEach(({ id }) => { document.getElementById(id)?.remove(); }); };
  }, []);

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const infoRows = [
    {
      label: t('page.company.info.name.label'),
      content: (
        <div>
          <p>{t('page.company.info.name.value')}</p>
          <p className="text-sm text-gray-500 mt-1">{t('page.company.info.name.rep')}</p>
        </div>
      ),
    },
    { label: t('page.company.info.founded.label'), content: <p>{t('page.company.info.founded.value')}</p> },
    {
      label: t('page.company.info.address.label'),
      content: <p style={{ whiteSpace: 'pre-line' }}>{t('page.company.info.address.value')}</p>,
    },
    {
      label: t('page.company.info.business.label'),
      content: (
        <div className="space-y-3">
          <div>
            <p className="font-medium mb-1">{t('page.company.info.business1.title')}</p>
            <p className="text-sm text-gray-600">{t('page.company.info.business1.desc')}</p>
          </div>
          <div>
            <p className="font-medium mb-1">{t('page.company.info.business2.title')}</p>
            <p className="text-sm text-gray-600">{t('page.company.info.business2.desc')}</p>
          </div>
        </div>
      ),
    },
    {
      label: t('page.company.info.credential.label'),
      content: (
        <div className="flex items-center gap-2">
          <i className="ri-award-line text-[#255485] text-xl w-6 h-6 flex items-center justify-center"></i>
          <span>{t('page.company.info.credential.value')}</span>
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex flex-col leading-none cursor-pointer">
            <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.18em' }} className="text-[#255485] font-bold text-2xl tracking-widest uppercase">LIKES</span>
            <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.22em' }} className="text-[#255485]/70 text-[9px] font-medium tracking-[0.22em] uppercase mt-0.5">Co, Ltd</span>
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/#vision" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium cursor-pointer">{t('nav.vision')}</Link>
            <Link to="/#services" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium cursor-pointer">{t('nav.services')}</Link>
            <Link to="/#csr" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium cursor-pointer">{t('nav.csr')}</Link>
            <Link to="/#company" className="text-gray-700 hover:text-[#255485] transition-colors duration-200 text-sm font-medium cursor-pointer">{t('nav.company')}</Link>
            <LanguageSwitcher />
            <button onClick={scrollToContact} className="bg-[#255485] text-white px-6 py-2.5 rounded-lg hover:bg-[#1d4166] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer">{t('nav.contact')}</button>
          </nav>
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer">
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <nav className="flex flex-col px-6 py-4 space-y-3">
              <div className="flex items-center gap-2 py-1"><span className="text-xs text-gray-500">Language</span><LanguageSwitcher /></div>
              <Link to="/#vision" className="text-gray-700 hover:text-[#255485] text-sm font-medium cursor-pointer py-2">{t('nav.vision')}</Link>
              <Link to="/#services" className="text-gray-700 hover:text-[#255485] text-sm font-medium cursor-pointer py-2">{t('nav.services')}</Link>
              <Link to="/#csr" className="text-gray-700 hover:text-[#255485] text-sm font-medium cursor-pointer py-2">{t('nav.csr')}</Link>
              <Link to="/#company" className="text-gray-700 hover:text-[#255485] text-sm font-medium cursor-pointer py-2">{t('nav.company')}</Link>
              <button onClick={scrollToContact} className="bg-[#255485] text-white px-6 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer text-center">{t('nav.contact')}</button>
            </nav>
          </div>
        )}
      </header>

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://public.readdy.ai/ai/img_res/b6499d28dc62c73d715ba9770cd38175.jpg" alt="会社概要" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <p className="text-white/90 text-xs sm:text-sm font-medium tracking-wider mb-4">{t('page.company.hero.eyebrow')}</p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white mb-6 leading-tight">{t('page.company.hero.title')}</h1>
            <p className="text-white/90 text-base md:text-lg leading-relaxed" style={{ whiteSpace: 'pre-line' }}>{t('page.company.hero.subtitle')}</p>
          </div>
        </div>
      </section>

      {/* Message */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="mb-16 text-center">
            <p className="text-[#255485] text-sm font-medium tracking-wider mb-2">{t('page.company.message.eyebrow')}</p>
            <h2 className="text-3xl md:text-4xl font-serif text-gray-900">{t('page.company.message.title')}</h2>
          </div>
          <div className="max-w-3xl mx-auto mb-16">
            <div className="prose prose-lg max-w-none">
              {(['p1','p2','p3','p4'] as const).map((key) => (
                <p key={key} className="text-gray-700 leading-relaxed mb-6">{t(`page.company.message.${key}`)}</p>
              ))}
              <p className="text-gray-700 leading-relaxed font-medium mb-8">{t('page.company.message.p5')}</p>
              <div className="text-right">
                <p className="text-gray-600 text-sm mb-1">{t('page.company.message.role')}</p>
                <p className="text-gray-900 text-lg font-medium">阿高 佳男　<span className="text-sm font-normal text-gray-500">Yoshio ATAKA</span></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Info */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="mb-16">
            <p className="text-[#255485] text-sm font-medium tracking-wider mb-2">{t('page.company.info.eyebrow')}</p>
            <h2 className="text-2xl md:text-3xl font-serif text-gray-900">{t('page.company.info.title')}</h2>
          </div>
          <div className="bg-white rounded-xl border border-gray-200">
            <div className="divide-y divide-gray-200">
              {infoRows.map((row) => (
                <div key={row.label} className="flex flex-col sm:flex-row py-6 px-8">
                  <div className="w-full sm:w-1/3 text-gray-600 font-medium mb-2 sm:mb-0">{row.label}</div>
                  <div className="w-full sm:w-2/3 text-gray-900">{row.content}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-6">{t('page.company.cta.title')}</h2>
          <p className="text-gray-600 leading-relaxed mb-10" style={{ whiteSpace: 'pre-line' }}>{t('page.company.cta.body')}</p>
          <button onClick={scrollToContact} className="bg-[#255485] text-white px-12 py-4 rounded-lg hover:bg-[#1d4166] transition-colors duration-200 text-base font-medium whitespace-nowrap cursor-pointer inline-flex items-center gap-2">
            {t('page.company.cta.button')}<i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <Link to="/" className="flex flex-col leading-none mb-4 cursor-pointer">
                <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.18em' }} className="text-white font-bold text-2xl tracking-widest uppercase">LIKES</span>
                <span style={{ fontFamily: "'Georgia', 'Times New Roman', serif", letterSpacing: '0.22em' }} className="text-white/70 text-[9px] font-medium tracking-[0.22em] uppercase mt-0.5">Co, Ltd</span>
              </Link>
              <p className="text-white/70 text-sm leading-relaxed" style={{ whiteSpace: 'pre-line' }}>{t('subpage.footer.tagline')}</p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">{t('subpage.footer.nav')}</h3>
              <nav className="space-y-3">
                <Link to="/#vision" className="block text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('nav.vision')}</Link>
                <Link to="/#services" className="block text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('nav.services')}</Link>
                <Link to="/#csr" className="block text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('nav.csr')}</Link>
                <Link to="/#company" className="block text-white/70 hover:text-white transition-colors duration-200 text-sm cursor-pointer">{t('nav.company')}</Link>
                <button onClick={scrollToContact} className="block text-white/70 hover:text-white text-sm cursor-pointer text-left">{t('nav.contact')}</button>
              </nav>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">{t('subpage.footer.contact')}</h3>
              <p className="text-white/70 text-sm leading-relaxed mb-4">{t('subpage.footer.address')}</p>
              <button onClick={scrollToContact} className="text-white/70 hover:text-white transition-colors duration-200 text-sm underline cursor-pointer">{t('nav.contact')}</button>
              <div className="mt-8">
                <h3 className="text-white font-semibold mb-3">{t('subpage.footer.related')}</h3>
                <a href="https://www.ikimonogakari.jp/" target="_blank" rel="noopener noreferrer nofollow" className="inline-block cursor-pointer">
                  <img src="https://static.readdy.ai/image/26970d9518e2e09002ea7ff933ab8760/5b8b09492cb52be1efa246b8b18519da.png" alt="いきものがかり" className="h-14 w-auto object-contain" style={{ filter: 'brightness(0) invert(1)' }} />
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-white/10 pt-8 text-center">
            <p className="text-white/50 text-sm">{t('subpage.footer.copyright')}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
